import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ControlDusStateService } from './control-dus-state.service';
import { LoggerService } from '../core/services/logger.service';

const VALID_KEYS = [
    'clienteId',
    'nave',
    'dateFrom',
    'dateTo',
    'referenciaCliente',
    'contenedor',
    'dus',
    'booking',
    'etapa',
    'estado',
    'page',
    'limit',
    'orderBy',
    'orderDirection',
];

@Injectable({
    providedIn: 'root',
})
export class ControlDusNavigationService {
    constructor(
        // eslint-disable-next-line no-unused-vars
        private router: Router,
        // eslint-disable-next-line no-unused-vars
        private stateService: ControlDusStateService,
        // eslint-disable-next-line no-unused-vars
        private logger: LoggerService
    ) {}

    navigateToDetail(nroIE: number): void {
        const state = this.stateService.getCurrentState();
        const queryParams = this.stateService.stateToQueryParams(state);
        this.logger.info(
            `Navegando a detalle Control DUS nroIE=${nroIE} con estado conservado`,
            'ControlDusNavigationService'
        );
        this.router.navigate(['/control-dus', nroIE], { queryParams });
    }

    /** Abre el detalle en una nueva pestaña (misma URL y query params que navigateToDetail). */
    openDetailInNewTab(nroIE: number): void {
        const state = this.stateService.getCurrentState();
        const queryParams = this.stateService.stateToQueryParams(state);
        this.logger.info(
            `Abriendo detalle Control DUS nroIE=${nroIE} en nueva pestaña con estado conservado`,
            'ControlDusNavigationService'
        );
        const urlTree = this.router.createUrlTree(['/control-dus', nroIE], {
            queryParams,
        });
        const url = this.router.serializeUrl(urlTree);
        window.open(url, '_blank', 'noopener,noreferrer');
    }

    backToList(): void {
        const state = this.stateService.getCurrentState();
        const queryParams = this.stateService.stateToQueryParams(state);
        this.logger.info(
            'Regresando al listado Control DUS con estado conservado',
            'ControlDusNavigationService'
        );
        this.router.navigate(['/control-dus'], { queryParams });
    }

    loadStateFromUrl(route: ActivatedRoute): boolean {
        const params = route.snapshot.queryParams || {};
        if (!this.hasValidQueryParams(params)) return false;
        const state = this.stateService.queryParamsToState(params);
        this.logger.info(
            `Cargando estado Control DUS desde URL`,
            'ControlDusNavigationService'
        );
        this.stateService.updateState(state);
        return true;
    }

    private hasValidQueryParams(params: Record<string, unknown>): boolean {
        return VALID_KEYS.some(
            (k) =>
                Object.prototype.hasOwnProperty.call(params, k) &&
                params[k] != null &&
                String(params[k]).length > 0
        );
    }
}
